// AXIOS
import axios from "axios";

// API URL
import { apiUrl_forSliders } from "./constants";

// CANCEL TOKEN
const CancelToken = axios.CancelToken;

// GET SLIDERS
export let cancelGetSlidersApi;
export async function getSliders_API(headers, query) {
    if(headers) {
        const data = await axios.get(
            apiUrl_forSliders + `s?${query}`,
            {
                headers: { ...headers },
            },
            {
                cancelToken: new CancelToken(function executor(c) {
                    // An executor function receives a cancel function as a parameter
                    cancelGetSlidersApi = c;
                }),
            }
        );

        return data;
    } else {
        console.log("Please add required parameters");
    }
}

// add sliders
export let cancelAddSlidersApi;
export async function addSliders_API(headers, { image, link, caption }) {
    if(headers && image) {
        let formData = new FormData();
        formData.append("images[]", image, image.name);

        if(link) {
            formData.append("link", link);
        } else {
            formData.append("link", "");
        }
        if(caption) {
            formData.append("caption", caption);
        } else {
            formData.append("caption", "");
        }

        const data = await axios.post(
            apiUrl_forSliders,
            formData,
            {
                headers: { ...headers },
            },
            {
                cancelToken: new CancelToken(function executor(c) {
                    // An executor function receives a cancel function as a parameter
                    cancelAddSlidersApi = c;
                }),
            }
        );

        return data;
    } else {
        console.log("Please add required parameters");
    }
}

// edit sliders
export let cancelEditSlidersApi;
export async function editSliders_API(headers, { sliderId, image, link, caption }) {
    if(headers && sliderId) {
        let formData = new FormData();

        if(image?.name) {
            formData.append("images[]", image, image.name);
        }
        if(link) {
            formData.append("link", link);
        } else {
            formData.append("link", "");
        }
        if(caption) {
            formData.append("caption", caption);
        } else {
            formData.append("caption", "");
        }

        const data = await axios.put(
            apiUrl_forSliders + `/${sliderId}`,
            formData,
            {
                headers: { ...headers },
            },
            {
                cancelToken: new CancelToken(function executor(c) {
                    // An executor function receives a cancel function as a parameter
                    cancelAddSlidersApi = c;
                }),
            }
        );

        return data;
    } else {
        console.log("Please add required parameters");
    }
}

// get sliders details 
export let cancelGetSliderDetailsApi;
export async function getSliderDetails_API(headers, sliderId) {
    if(headers && sliderId) {
        const data = await axios.get(
            apiUrl_forSliders + `/${sliderId}`,
            {
                headers: { ...headers },
            },
            {
                cancelToken: new CancelToken(function executor(c) {
                    // An executor function receives a cancel function as a parameter
                    cancelGetSliderDetailsApi = c;
                }),
            }
        );

        return data;
    } else {
        console.log("Please add required parameters");
    }
}

// get sliders details 
export let cancelDeleteSliderApi;
export async function deleteSlider_API(headers, sliderId) {
    if(headers && sliderId) {
        const data = await axios.delete(
            apiUrl_forSliders + `/${sliderId}`,
            {
                headers: { ...headers },
            },
            {
                cancelToken: new CancelToken(function executor(c) {
                    // An executor function receives a cancel function as a parameter
                    cancelDeleteSliderApi = c;
                }),
            }
        );

        return data;
    } else {
        console.log("Please add required parameters");
    }
}